import { render, staticRenderFns } from "./setItem.vue?vue&type=template&id=37c75822&"
import script from "./setItem.vue?vue&type=script&lang=js&"
export * from "./setItem.vue?vue&type=script&lang=js&"
import style0 from "./setItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports